// extracted by mini-css-extract-plugin
export var cta_block = "index-module--cta_block--42a37";
export var cta_container = "index-module--cta_container--67034";